<div class="popup-container">
  @if (isLoading) {
    <div class="loading-state">
      <app-rings-loader class="bg-transparent"></app-rings-loader>
    </div>
  }

  @if (!isLoading && taskGroup) {
    <div class="popup-header">
      <div class="popup-title-row">
        <h2 class="popup-title">{{ taskGroup.name }}</h2>
      </div>
      <div class="popup-meta">
        @if (taskGroup.organizationLevelName) {
          <span class="meta-item">
            <mat-icon class="meta-icon">business</mat-icon>
            {{ taskGroup.organizationLevelName }}
          </span>
        }
        @if (taskGroup.addedToMySite) {
          <span class="site-badge site-badge--added">
            <mat-icon class="site-badge__icon">check_circle</mat-icon>
            {{ 'On My Site' | translate }}
          </span>
        }
      </div>
      <div class="popup-actions">
        <button class="btn btn-submit mr-2" (click)="openEditGroupDialog()">
          {{ 'Edit Group' | translate }}
        </button>
        <button class="btn btn-submit" (click)="openAssignDialog()">
          <mat-icon class="btn-icon">assignment_ind</mat-icon>
          {{ 'Assign' | translate }}
        </button>
      </div>
    </div>
    <mat-tab-group [mat-stretch-tabs]="false" class="popup-tabs">
      <mat-tab label="{{ 'Tasks' | translate }}">
        <div class="tab-content">
          <div class="tab-toolbar">
            <span class="tab-count">
              {{ tasksDataSource.data.length }} {{ 'Tasks' | translate | lowercase }}
            </span>
            <button class="btn btn-primary" (click)="openCreateTaskDialog()">
              <mat-icon class="btn-icon">add</mat-icon>
              {{ 'Create New Task' | translate }}
            </button>
          </div>
          <div class="custom-theme-table">
            <div class="custom-scrollbar table-responsive outer-bordered-table">
              <table mat-table class="table table-striped" [dataSource]="tasksDataSource">
                <tr class="mat-row" *matNoDataRow [ngClass]="{'loading-row': isTasksLoading}">
                  <td class="mat-cell text-center" [attr.colspan]="tasksColumns.length">
                    @if (isTasksLoading) {
                      <app-rings-loader class="bg-transparent"></app-rings-loader>
                    } @else {
                      {{ 'No tasks in this group' | translate }}
                    }
                  </td>
                </tr>
                <ng-container matColumnDef="name">
                  <th class="left-aligned" mat-header-cell *matHeaderCellDef>{{ 'Task Name' | translate }}</th>
                  <td class="left-aligned" mat-cell *matCellDef="let task">{{ task.name }}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th class="text-center" mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
                  <td class="text-center" mat-cell *matCellDef="let task">
                    <i class="material-icons cursor-pointer material-grey-icon big-icon"
                      [title]="'Update' | translate"
                    (click)="openEditTaskDialog(task.id)">edit</i>
                    <i class="material-icons cursor-pointer material-grey-icon big-icon"
                      [title]="'Delete' | translate"
                    (click)="openDeleteTaskDialog(task)">delete</i>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tasksColumns"></tr>
                <tr mat-row *matRowDef="let row; let even = even; columns: tasksColumns;" [class.even-row]="even"></tr>
              </table>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  }
</div>
